// This file should only be changed by the `bin/console sulu:admin:update-build` command:
// See https://docs.sulu.io/en/latest/upgrades/upgrade-2.x.html

// Sulu Core Bundles
import { startAdmin as originalStartAdmin } from "sulu-admin-bundle";
import "sulu-audience-targeting-bundle";
import "sulu-category-bundle";
import "sulu-contact-bundle";
import "sulu-custom-url-bundle";
import "sulu-location-bundle";
import "sulu-media-bundle";
import "sulu-page-bundle";
import "sulu-preview-bundle";
import "sulu-route-bundle";
import "sulu-search-bundle";
import "sulu-security-bundle";
import "sulu-snippet-bundle";
import "sulu-trash-bundle";
import "sulu-website-bundle";
import * as Sentry from "@sentry/react";

// Add project specific javascript code and import of additional bundles to the following file:
import "./app.js";

// Suppresing sulu default message on load
function startAdmin() {
    console._original = console.log;
    console.log = function () {};
    originalStartAdmin();
    console.log = console._original || console.log;
}

Sentry.init({
    dsn: "https://eb12940d48dc3e6b4c3bfac6ee0bb11e@o4508714899341312.ingest.de.sentry.io/4508715099357264",
    integrations: [],
});

// Start admin application
startAdmin();
